import { render, staticRenderFns } from "./MaydayWebProductViewer.vue?vue&type=template&id=b66483ba&scoped=true&"
import script from "./MaydayWebProductViewer.vue?vue&type=script&lang=js&"
export * from "./MaydayWebProductViewer.vue?vue&type=script&lang=js&"
import style0 from "./MaydayWebProductViewer.vue?vue&type=style&index=0&id=b66483ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66483ba",
  null
  
)

export default component.exports